// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__afEna","info":"PatientInfo_info__8W0Af"};